module.exports = __webpack_public_path__ + "img/profile_icon.e8647675.png";